// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2WRxl","inputWrap":"Table_inputWrap__3X7hx","col":"Table_col__2s_-1","bmiTooltip":"Table_bmiTooltip__HrFZc"};